import {ViewOptionsSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {useTranslation} from '@aboutyou/i18n';
import {useViewOptionsTracking} from '@aboutyou/tracking';
import {
  FilterDropdownSelect,
  FilterFlyoutIconName,
  ProductImageType,
} from '@aboutyou/ui-components';
import React from 'react';
import {normalizeProductImageType} from '../../shared/normalizeProductImageType';

interface Props {
  data: ViewOptionsSection;
  onChangeProductImageType: (productImageType: ProductImageType) => void;
  productImageType?: ProductImageType;
}

export const FilterSectionViewOptions: React.FC<Props> = ({
  data,
  productImageType,
  onChangeProductImageType,
}) => {
  const defaultProductImageType = normalizeProductImageType(data);
  const {t} = useTranslation();
  const viewOptions = useViewOptions();

  const {trackOnCloseView, trackOnOpenView, trackOnSelect} =
    useViewOptionsTracking();

  const handleOnSelect = (optionId: string) => {
    onChangeProductImageType(optionId! as ProductImageType);
    trackOnSelect(optionId);
  };

  return (
    <FilterDropdownSelect
      dataTestId="viewOptionsDropdown"
      label={t('View')}
      displayIcon={FilterFlyoutIconName.Shirt}
      onSelect={handleOnSelect}
      activeOptionId={productImageType}
      defaultOptionId={defaultProductImageType}
      options={viewOptions}
      onClose={trackOnCloseView}
      onOpen={trackOnOpenView}
      renderInPortal={false}
    />
  );
};

const useViewOptions = () => {
  const {t} = useTranslation();

  return [
    {id: 'product', label: t('Item view')},
    {id: 'model', label: t('View model')},
  ];
};
